// import React from "react";
// import { X, CheckCircle, Clock } from "lucide-react";
// import { useNavigate } from "react-router-dom";

// const Popup = ({
//   message,
//   type,
//   onClose,
//   children,
//   navigateTo,
//   navigateState,
//   showchildren = false,
// }) => {
//   const navigate = useNavigate();

//   const handleOkClick = () => {
//     if (navigateTo) {
//       navigate(navigateTo, { state: navigateState });
//     }
//     onClose();
//   };

//   const renderIcon = () => {
//     if (type === "success") {
//       return <CheckCircle className="w-12 h-12 text-green-500 animate-glow" />;
//     }

//     if (type === "pending") {
//       return <Clock className="w-12 h-12 text-yellow-500 animate-spinSlow" />;
//     }

//     return <X className="w-12 h-12 text-red-500 animate-glow" />;
//   };

//   return (
//    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-md no-print">
//       <div className="relative w-[90%] max-w-lg p-6 rounded-lg shadow-xl bg-white min-h-[250px]
//                       flex flex-col items-center justify-center md:p-8 animate-fadeIn">

//         {/* ICON */}
//         <div className="relative flex items-center justify-center">
//           <div className="absolute w-16 h-16 bg-gray-300 opacity-30 rounded-full animate-pulseBlur"></div>
//           {renderIcon()}
//         </div>

//         {/* MESSAGE */}
//         {/* {message && (
//           <p className="text-center text-black text-lg font-medium mt-6">
//             {message}
//           </p>
//         )} */}
//         {message && (
//           <p className="text-center text-black text-lg font-medium mt-6 whitespace-pre-line">
//             {message}
//           </p>
//         )}

//         {/* CHILDREN */}
//         {showchildren && (
//           <div className="mt-4 w-full flex flex-col items-center">
//             {children}
//           </div>
//         )}

//         {/* OK BUTTON (success & pending only) */}
//         {navigateTo && type !== "error" && (
//           <button
//             className={`mt-6 px-6 py-2 text-white rounded-md transition-all
//               ${type === "pending"
//                 ? "bg-yellow-500 hover:bg-yellow-600"
//                 : "bg-blue-600 hover:bg-blue-700"
//               }`}
//             onClick={handleOkClick}
//           >
//             OK
//           </button>
//         )}

//         {/* CLOSE */}
//         <div className="absolute top-2 right-2">
//           <button
//             className="p-2 rounded-full bg-white hover:bg-gray-200 transition-all"
//             onClick={onClose}
//           >
//             <X className="w-6 h-6 text-gray-600 hover:text-red-500" />
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Popup;


import React from "react";
import { X, CheckCircle, Clock } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Popup = ({
  message,
  type = "success", // success | error | pending
  onClose,
  children,
  navigateTo,
  navigateState,
  showchildren = false,
}) => {
  const navigate = useNavigate();

  const handleOkClick = () => {
    if (navigateTo) {
      navigate(navigateTo, { state: navigateState });
    }
    onClose();
  };

  const renderIcon = () => {
    if (type === "success") {
      return <CheckCircle className="w-12 h-12 text-green-500 animate-glow" />;
    }

    if (type === "pending") {
      return <Clock className="w-12 h-12 text-yellow-500 animate-spinSlow" />;
    }

    return <X className="w-12 h-12 text-red-500 animate-glow" />;
  };

  return (
    /* OVERLAY – ALWAYS CENTER */
    <div className="fixed inset-0 z-[999] no-print
                    bg-black/50 backdrop-blur-md
                    flex items-center justify-center">

      {/* MODAL */}
      <div
        className="relative w-[90%] max-w-lg min-h-[250px]
                   bg-white rounded-lg shadow-xl
                   flex flex-col items-center justify-center
                   p-6 md:p-8 animate-fadeIn"
      >
        {/* ICON */}
        <div className="relative flex items-center justify-center">
          <div className="absolute w-16 h-16 bg-gray-300 opacity-30 rounded-full animate-pulseBlur"></div>
          {renderIcon()}
        </div>

        {/* MESSAGE */}
        {message && (
          <p className="mt-6 text-center text-black text-lg font-medium whitespace-pre-line">
            {message}
          </p>
        )}

        {/* CHILDREN */}
        {showchildren && (
          <div className="mt-4 w-full flex flex-col items-center">
            {children}
          </div>
        )}

        {/* OK BUTTON (success & pending only) */}
        {navigateTo && type !== "error" && (
          <button
            onClick={handleOkClick}
            className={`mt-6 px-6 py-2 rounded-md text-white font-semibold transition-all
              ${
                type === "pending"
                  ? "bg-yellow-500 hover:bg-yellow-600"
                  : "bg-blue-600 hover:bg-blue-700"
              }`}
          >
            OK
          </button>
        )}

        {/* CLOSE BUTTON */}
        <button
          onClick={onClose}
          className="absolute top-2 right-2 p-2 rounded-full
                     bg-white hover:bg-gray-200 transition-all"
        >
          <X className="w-6 h-6 text-gray-600 hover:text-red-500" />
        </button>
      </div>
    </div>
  );
};

export default Popup;
